import { resolveAppKgobBase } from '@/lib/getYourAnswerApi';

export const siteConfig = {
  firm: "KGOB CPAs & Advisors",
  tagline: "LET'S TALK GROWTH®",
  address: {
    line1: "2740 East WT Harris Blvd, Suite 200",
    city: "Charlotte",
    state: "NC",
    zip: "28213",
    country: "USA",
  },
  phone: "+1-844-599-3355",
  phoneDisplay: "1-844-599-3355",
  email: "connect@kgob.com",
  socials: {
    linkedin: "https://www.linkedin.com/company/kgobcpa/",
    x: "https://x.com/kgobcpa",
    instagram: "https://www.instagram.com/kgobcpa",
  },
  portals: {
    client: `${resolveAppKgobBase()}/portal/login`,
  },
  supportHours: {
    weekday: "Monday - Friday, 9am - 6pm EST",
    saturday: "Saturday, 10am - 2pm EST",
    sunday: "Sunday, Closed",
  },
};

export const products = [
  { 
    slug: "asksara", 
    name: "AskSara.cpa", 
    tagline: "AI-powered clarity for complex financial decisions.",
    desc: "KGOB's proprietary AI advisor helps decode tax data, uncover savings, and guide confident choices. AskSara brings human expertise and machine precision together to simplify what used to feel overwhelming.", 
    url: "#",
    tag: "AI"
  },
  { 
    slug: "bizhub", 
    name: "BizHub.com", 
    tagline: "Launching smarter businesses and strengthening established ones.",
    desc: "BizHub is a comprehensive platform for business owners and professionals — offering curated educational content, implementation tools, expert-vetted services, and community collaboration. It fosters growth by combining learning with action and enables entrepreneurs to scale confidently.", 
    url: "#",
    tag: "Platform"
  },
  { 
    slug: "letstalkgrowth", 
    name: "LetsTalkGrowth.com", 
    tagline: "Measure, understand, and grow the value of your business.",
    desc: "Let's Talk Growth gives business owners a clear picture of their company's worth and actionable strategies to increase it. Through data-driven valuation tools and AI-powered insights, it transforms financial complexity into clear, measurable growth paths.", 
    url: "https://letstalkgrowth.com",
    tag: "Advisory"
  },
  { 
    slug: "letstalkstrategy", 
    name: "LetsTalkStrategy.io", 
    tagline: "High-impact tax strategy and implementation — simplified.",
    desc: "Let's Talk Strategy helps high-income individuals and business owners unlock tax savings through advanced strategy design and transparent reporting. Our system delivers both insight and execution — ensuring every decision supports your long-term goals.", 
    url: "#",
    tag: "Tax"
  },
  { 
    slug: "letstalkrelief", 
    name: "LetsTalkRelief.com", 
    tagline: "Peace of mind for those navigating IRS issues and compliance stress.",
    desc: "Let's Talk Relief provides a secure platform for clients facing IRS notices, back taxes, and audit concerns. It combines automation, document tracking, and expert guidance to help individuals and businesses resolve issues efficiently and confidently.", 
    url: "https://letstalkrelief.com",
    tag: "Resolution"
  },
  { 
    slug: "letstalktaxes", 
    name: "LetsTalkTaxes.io", 
    tagline: "Clarity and confidence for every taxpayer.",
    desc: "Let's Talk Taxes helps individuals and business owners estimate their 2025 tax liability and see the impact of new tax law changes. Designed for simplicity and accuracy, it transforms complex IRS data into clear, actionable insights—so you can plan ahead, adjust withholding, and make smarter financial decisions with peace of mind.", 
    url: "https://letstalktaxes.io",
    tag: "TAX"
  },
];

export const INDUSTRIES = [
  "Real Estate",
  "Healthcare",
  "Technology",
  "Manufacturing",
  "Retail",
  "Professional Services",
  "Construction",
  "Hospitality",
  "Non-Profit",
  "Entertainment",
  "Automotive",
  "Financial Services",
  "Education",
  "Agriculture"
];